import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

import { ChatMessageEvent } from '../../models/communication/app-events.model';

@Component({
    selector: 'app-chat',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './chat.component.html',
    styleUrl: './chat.component.scss'
})
export class ChatComponent implements OnChanges {
    @ViewChild('messagesEl') messagesEl?: ElementRef<HTMLElement>;

    @Input()
    chatEnabled? = false;

    @Input()
    messages?: ChatMessageEvent[];

    @Output()
    readonly toggleClicked = new EventEmitter<HTMLButtonElement>();

    protected pinnedMessage?: ChatMessageEvent;
    protected scrollBarIsVisible = false;

    ngOnChanges(changes: Partial<SimpleChanges>): void {
        if (changes.messages) {
            this.pinnedMessage = this.messages?.find((message) => message.isSupervisor);

            setTimeout(() => {
                const element = this.messagesEl?.nativeElement;
                if (!element) {
                    return;
                }

                this.scrollBarIsVisible = element.scrollHeight > element.clientHeight;

                if (this.scrollBarIsVisible) {
                    // Initial scroll effect
                    if (changes.messages?.firstChange) {
                        // Because flex-direction is column-reverse,
                        // the scroll bar is at the bottom initially.
                        // We move it to the top before scrolling.
                        element.scrollTop = -10e5;
                    }

                    element.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            });
        }
    }
}
